import { useT } from "@/app/hooks/useT";
import type { PaymentTransaction } from "@/app/types/payments";
import { formatDate } from "@/app/utils/DateFormater";
import { gxDateTimeFormat } from "@/app/utils/helpers/gxDateTimeFormat";
import { MaskedAccountField } from "@/app/utils/MaskedAccountField";
import { SvgIcon } from "@progress/kendo-react-common";
import { chevronDownIcon, chevronUpIcon } from "@progress/kendo-svg-icons";
import { useState } from "react";

interface TransferFromProp {
  transaction: PaymentTransaction;
}
export const TransferFrom = ({ transaction }: TransferFromProp) => {
  const t = useT();
  const [isTransferFromOpen, setIsTransferFromOpen] = useState<boolean>(true);

  return (
    <div className="gx-transaction-detail-card">
      <button
        className="gx-transaction-detail-card-header"
        onClick={() => setIsTransferFromOpen(!isTransferFromOpen)}
      >
        <h2 className="gx-transaction-detail-card-title gx-h3-b">{t("transfer_from")}</h2>
        <SvgIcon
          icon={isTransferFromOpen ? chevronUpIcon : chevronDownIcon}
          size="small"
        />
      </button>
      {isTransferFromOpen && (
        <div className="gx-transaction-detail-card-body">
          <div className="gx-transaction-detail-row">
            <span className="gx-t-lable">{t("account_name")}</span>
            <span className="gx-t-value">
              {transaction?.debitAccountName || "---"}
            </span>
          </div>
          <div className="gx-transaction-detail-row">
            <span className="gx-t-lable">{t("account_nickname")}</span>
            <span className="gx-t-value">
              {transaction?.accountNickname || "---"}
            </span>
          </div>

          <MaskedAccountField
            label={t("account")}
            accountNumber={transaction?.debitAccountNo || "---"}
          />

          <div className="gx-transaction-detail-row">
            <span className="gx-t-lable">{t("bank_name")}</span>
            <span className="gx-t-value">
              {transaction?.debitBankName || "---"}
            </span>
          </div>
          <div className="gx-transaction-detail-row">
            <span className="gx-t-lable">{t("transfer_type")}</span>
            <span className="gx-t-value">
              {transaction?.paymentTypeName || "---"}
            </span>
          </div>
          <div className="gx-transaction-detail-row">
            <span className="gx-t-lable">{t("transfer_date")}</span>
            {transaction?.paymentDate && (
              <span className="gx-t-value">
                {formatDate(transaction?.paymentDate)}
              </span>
            )}
          </div>
          <div className="gx-transaction-detail-row">
            <span className="gx-t-lable">{t("request_date_time")}</span>
            {transaction?.paymentInitiatedDate && (
              <span className="gx-t-value">
                {gxDateTimeFormat(transaction?.paymentInitiatedDate)}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
